document.addEventListener('DOMContentLoaded', () => {
  const postsSliderEl = document.querySelector('.posts-slider')
  if (postsSliderEl) {
    const navButtons = document.querySelectorAll('.post-nav-btn')
    navButtons.forEach((navBtnEl) => {
      const isPrev = navBtnEl.classList.contains('post-prev-btn')
      navBtnEl.addEventListener('click', (e) => {
        e.preventDefault()

        const action = isPrev ? 'slickPrev' : 'slickNext'
        jQuery(postsSliderEl).slick(action)
      })
    })
  }
})
